import { config } from "config";
import { SetCertificatesPayload, CertificateState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;
const initialState: CertificateState = {
  count: 0,
  certificates: [],
  certificate: null,
  loading: true,
  refresh: 0,
  current_filters: {},
  refreshLoader: false,
  certificateOptions: [],
  options:[],
  filters: { page: 1, pageSize: default_page_size },
};

export const certificateSlice = createSlice({
  name: "certificate",
  initialState,
  reducers: { 
    clear_search: (state) => {
      state.certificates = [];
      state.certificateOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    
    setOptions: (state, action: PayloadAction<any[]>) => {
      state.options = action.payload;
    },
    updateCertificate: (state, action) => {
      const { id, certificate } = action.payload;
      state.certificates.every(({ _id }, i) => {
        if (id === _id) {
          state.certificates[i] = certificate;
          return false;
        }
        return true;
      });
    },
    deleteCertificateById: (state, action) => {
      const id = action.payload;
      state.certificates.every(({ _id }, i) => {
        if (id === _id) {
          state.count -= 1;
          state.certificates.splice(i, 1);
          return false;
        }
        return true;
      });
    },
    setCertificate: (state, action) => {
      state.certificate = action.payload;
    },

    addCertificate: (state, action) => {
      state.certificates.unshift(action.payload);
    },

    setCertificates: (state, action: PayloadAction<SetCertificatesPayload>) => {
      const { count, certificates } = action.payload;
      state.count = count;
      state.refreshLoader = false;

      let options: SelectOption[] = [];
      certificates.forEach(({ _id, fullName, email }: any) =>
        options.push({ value: _id, label: fullName + " " + email })
      );
      state.certificates = certificates;
      state.certificateOptions = options;
    },
    setSearchCertificates: (state, action: PayloadAction<SetCertificatesPayload>) => {
      const { count, certificates } = action.payload;
      state.count = count;
      state.refreshLoader = false;

      let options: SelectOption[] = [];
      certificates.forEach(({ _id, fullName,email }: any) =>
        options.push({ value: _id, label: fullName + " "  +" - " +email })
      );
      state.certificates = certificates;
      state.certificateOptions = options;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
  },
});

const certificateReducer = certificateSlice.reducer;

export const certificateActions = certificateSlice.actions;
export default certificateReducer;
